<template>
  <v-text-field dense single-line readonly v-model="value" :rules="bdRules" class="hide-value" outlined :label="showDate ? '': 'Fødselsdato (DD.MM.YYYY)'" @focus="onFocus" @blur="focus=false">
    <template v-slot:prepend-inner>
        <div class="FormDate" @keyup.capture="updateValue" v-show="showDate">
        <input ref="day" v-model="day" :class="inputClass" style="width: 25%" type="number" placeholder="dd" @click="handleClick('day')" @input="updateDay" @focus="datefocus = true" @blur="datefocus = false">
        <span class="FormDate__divider">/</span>
        <input ref="month" v-model="month" :class="inputClass" style="width: 25%" type="number" placeholder="mm" @click="handleClick('month')" @input="updateMonth" @focus="datefocus = true" @blur="datefocus = false">
        <span class="FormDate__divider">/</span>
        <input ref="year" v-model="year" :class="inputClass" style="width: 33%" type="number" placeholder="yyyy" @click="handleClick('year')" @focus="datefocus = true" @blur="datefocus = false">
        </div>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: `FormDate`,
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      day: `${this.value ? new Date(this.value).getDate() : ``}`,
      month: `${this.value ? new Date(this.value).getMonth() + 1 : ``}`,
      year: `${this.value ? new Date(this.value).getFullYear(): ``}`,
      focus: false,
      datefocus: false,
      focusElement: "day",
      bdRules: [
        v => this.validDate(v) && !Number.isNaN(Date.parse(v)) ||'Fødselsdato er ugyldig'
      ]
    };
  },
  computed: {
      inputClass(){
          return 'FormDate__input'
      },
      showDate(){
          return this.focus || this.datefocus || this.day != '' || this.month != '' || this.year != '';
      }
  },
  watch: {
    year(current, prev) {
      if (current > 9999) this.year = prev;
    },
  },
  methods: {
    handleClick(el) {
        this.focusElement = el;
    },
    onFocus(){
        this.focus=true; 
        this.$nextTick(() => this.$refs[this.focusElement].focus());
    },
    updateDay() {
      if (this.day.length < 2 ) return;
      this.$refs.month.select();
    },
    updateMonth() {
      if (this.month.length < 2) return;
      this.$refs.year.select();
    },
    updateValue() {
      const stringDate = `${this.year}-${this.month}-${this.day}`
      if (Number.isNaN(Date.parse(stringDate))) this.$emit('invalid');
      else this.$emit(`input`, stringDate);
    },
    validDate(v) {
      return v.match(/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/) != null
    }
  },
};
</script>
<style scoped>
.FormDate {
  margin-top:-3px;
}

.FormDate__input {
    -moz-appearance: textfield;
    text-align: center;
}
.FormDate__input:focus {
    outline: none;
    border: none;
}
.FormDate__input::-webkit-inner-spin-button {
    display: none;
}
</style>
<style>
.hide-value .v-text-field__slot input {
    opacity: 0!important;
}
</style>